import { render, staticRenderFns } from "./StarterPackDrawerRedirect.vue?vue&type=template&id=13a2eadd&scoped=true"
import script from "./StarterPackDrawerRedirect.vue?vue&type=script&lang=js"
export * from "./StarterPackDrawerRedirect.vue?vue&type=script&lang=js"
import style0 from "./StarterPackDrawerRedirect.vue?vue&type=style&index=0&id=13a2eadd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2eadd",
  null
  
)

export default component.exports